import MenuItem from './MenuItem'

export default function Menu({
  id = null,
  title = null,
  items = [],
  code = null,
  // timestamp = + new Date(),
  // isFetching = false
}) {
  this._id = id
  this._title = title
  this._items = items.map(item => new MenuItem(item))
  this._code = code
  // this._timestamp = timestamp
  // this._isFetching = isFetching
}

Menu.prototype.getId = function() {
  return this._id
}

Menu.prototype.setId = function(id) {
  this._id = id
}

Menu.prototype.getTitle = function() {
  return this._title
}

Menu.prototype.setTitle = function(title) {
  this._title = title
}

Menu.prototype.getItems = function() {
  return this._items
}

Menu.prototype.setItems = function(items) {
  this._items = items.map(item => new MenuItem(item))
}

Menu.prototype.addItem = function(item) {
  this._items.push(new MenuItem(item))
}

// Menu.prototype.delItem = function(item) {
// }

Menu.prototype.getCode = function() {
  return this._code
}

Menu.prototype.setCode = function(code) {
  this._code = code
}

// Menu.prototype.getTimestamp = function() {
//   return this._timestamp
// }

// Menu.prototype.setTimestamp = function(timestamp) {
//   this._timestamp = timestamp
// }

// Menu.prototype.getIsFetching = function() {
//   return this._isFetching
// }

// Menu.prototype.setIsFetching = function(isFetching) {
//   this._isFetching = isFetching
// }



// WEBPACK FOOTER //
// ./src/entities/Menu.js